import { IncrementMapper } from './increment-mapper';

export class StartIncrementMapper extends IncrementMapper {
  initialized = false;

  map(_increment: number): number {
    return this.maxIncrement;
  }
}
